export default {
  title: 'Configure new load',
  submitLabel: '{recipeCode} laden',
};
